import styled from "styled-components";
import { Dialog, NonIdealState } from "@remhealth/ui";

export const FullCenterScreen = styled.main`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const ActionCell = styled.td`
  && {
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    padding-top: 0;
    padding-bottom: 0;
  }
`;

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const TabBar = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  height: 100%;

  .bp6-tabs {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    > .bp6-tab-panel {
      flex: 1 1 auto;
      min-height: 0;
      padding-top: 10px;
    }
  }

  @media (max-width: 600px) {
    .bp6-tab-list {
      padding-left: 5px;
      padding-right: 5px;
    }
  }
`;

export const MenuItemContainer = styled.div`
  span {
    display: flex;
  }
  span.bp6-popover-target {
    flex: 1 1;
  }
`;

const DotContainer = styled.span`
  font-size: 0.8em;
  margin: 0 0.5em;
`;

export interface DotProps {
  className?: string;
}

export function Dot(props: DotProps) {
  return <DotContainer {...props}>&#8226;</DotContainer>;
}

export const TabbedDialog = styled(Dialog)`
  display: flex;
  flex-direction: column;
  padding-bottom: 0;

  > .bp6-dialog-header {
    height: 50px;
    flex: 0 0 auto;

    > .bp6-heading {
      padding-left: 0;
    }

    .bp6-dialog-close-button {
      margin: 5px;
    }
  }

  > .bp6-dialog-footer {
    margin: 10px 20px 20px 20px;
  }

  > .bp6-dialog-body {
    padding: 0;
    flex: 1 1 auto;
    overflow: hidden;
    display: flex;
    flex-direction: column;

    > .bp6-tabs {
      display: flex;
      flex-direction: column;
      overflow: hidden;

      > .bp6-tab-list {
        flex: 0 0 auto;
        padding-left: 30px;
      }

      > .bp6-tab-panel {
        padding: 20px 30px;
        flex: 1 1 auto;
      }
    }
  }
`;

export interface LoadingMessageProps {
  title: string;
  description?: string;
}

export function LoadingMessage(props: LoadingMessageProps) {
  return (
    <FullCenterScreen>
      <NonIdealState loading {...props} />
    </FullCenterScreen>
  );
}
